import Modal from './Modal'

export default class BookList extends React.PureComponent
  EDIT_MODAL_ID = 'modal-primento-book-edit'

  constructor: (props) ->
    super(props)

    @state =
      books:           @props.books
      currentTab:      'active'
      searchTerm:      ''
      editedBook:      undefined
      selectedBookIds: []

    @selectFilterTab              = @selectFilterTab.bind(this)
    @updateSearchTerm             = @updateSearchTerm.bind(this)
    @clearSearchTerm              = @clearSearchTerm.bind(this)
    @hideModal                    = @hideModal.bind(this)
    @editBook                     = @editBook.bind(this)
    @updateBook                   = @updateBook.bind(this)
    @markInvoicingStatusAsPending = @markInvoicingStatusAsPending.bind(this)
    @markInvoicingStatusAsGifted  = @markInvoicingStatusAsGifted.bind(this)
    @invoiceBooks                 = @invoiceBooks.bind(this)

  visibleTabs: ->
    if @props.admin
      ['active', 'invoiced', 'deleted', 'all']
    else
      ['active', 'invoiced',            'all']

  reloadBooks: ->
    http.get('/primento/books.json', {}, (data) =>
      @setState(books: data)
    )

  # To compare without accentuation and special chars (ç)
  # cf. https://stackoverflow.com/a/37511463/1243212
  normalize: (text) ->
    text.toLowerCase().trim().normalize("NFD").replace(/\p{Diacritic}/gu, '')

  filteredBooks: ->
    if @state.currentTab == 'active'
      visibleBooks = @state.books.filter((book) => book.invoicingStatus == 'pending' && !book.isDestroyed)
    else if @state.currentTab == 'invoiced'
      visibleBooks = @state.books.filter((book) => book.invoicingStatus != 'pending' && !book.isDestroyed)
    else if @state.currentTab == 'deleted'
      visibleBooks = @state.books.filter((book) => book.isDestroyed)
    else if @state.currentTab == 'all'
      visibleBooks = @state.books

    if @state.searchTerm.trim() != ''
      searchTerm = @normalize(@state.searchTerm)

      visibleBooks = visibleBooks.filter((book) =>
        @normalize(book.name).includes(searchTerm)
      )

    visibleBooks

  selectFilterTab: (tab, e) ->
    e.preventDefault()

    @setState(
      currentTab:      tab
      selectedBookIds: []
    )

  updateSearchTerm: (e) ->
    @setState(
      searchTerm: e.target.value
    )

  clearSearchTerm: (e) ->
    @setState(
      searchTerm: ''
    )

  editBook: (book, e) ->
    @setState({
      editedBook: book
    }, @showModal)

  updateBook: (name) ->
    params =
      primento_book:
        name: name

    http.put("/primento/books/#{@state.editedBook.id}/update_name.json", params, (data) =>
      @reloadBooks()
      @hideModal()
      @setState(editedBook: undefined)
    )

  showModal: ->
    modal = Bootstrap.Modal.getOrCreateInstance("##{EDIT_MODAL_ID}")
    modal.show()

  hideModal: ->
    modal = Bootstrap.Modal.getOrCreateInstance("##{EDIT_MODAL_ID}")
    modal.hide()

  toggleBookSelection: (book) ->
    if @props.admin # not available for Primento staff
      if @state.selectedBookIds.includes(book.id)
        newSelectedBookIds = @state.selectedBookIds.filter((id) => id != book.id)
      else
        newSelectedBookIds = @state.selectedBookIds.concat([book.id])

      @setState(selectedBookIds: newSelectedBookIds)

  markInvoicingStatusAsPending: ->
    http.put("/primento/books/mark_as_pending.json", { ids: @state.selectedBookIds }, (data) =>
      @reloadBooks()
    )

    @setState(selectedBookIds: [])

  markInvoicingStatusAsGifted: ->
    http.put("/primento/books/mark_as_gifted.json", { ids: @state.selectedBookIds }, (data) =>
      @reloadBooks()
    )

    @setState(selectedBookIds: [])

  invoiceBooks: ->
    http.put("/primento/books/invoice.json", { ids: @state.selectedBookIds }, (data) =>
      @reloadBooks()
    )

    @setState(selectedBookIds: [])

  invoicingStatusText: (book) ->
    if book.invoicingStatus == 'gifted'
      title = "Gift: this book won't be invoiced"
    else if book.invoicingStatus == 'invoiced'
      title = "This book was invoiced"

  render: ->
    <div className="book-list">
      <div className="book-list-header">
        { @renderCreateButton() }
        { @renderSelectionActions() if @props.admin }

        <h1>Books</h1>
      </div>
      { @renderSearchField() }
      { @renderFilterTabs()  }
      { @renderTable()       }
      { @renderRenameModal() }
    </div>

  renderCreateButton: ->
    <button className="btn btn-primary float-end"
            data-bs-toggle="modal" data-bs-target="#new-book-modal">
      Create new book
    </button>

  renderSelectionActions: ->
    if @state.selectedBookIds.length
      <div className="selection-actions">
        {@state.selectedBookIds.length} selected books:&nbsp;&nbsp;
        <button className="btn btn-secondary btn-sm"
                onClick={@markInvoicingStatusAsPending}>
          Mark as pending
        </button>
        &nbsp;
        <button className="btn btn-secondary btn-sm"
                onClick={@markInvoicingStatusAsGifted}>
          Mark as gifted
        </button>
        &nbsp;
        <button className="btn btn-secondary btn-sm"
                onClick={@invoiceBooks}>
          Create invoice
        </button>
      </div>


  renderFilterTabs: ->
    renderedTabs = @visibleTabs().map((tab) =>
      classes =  "nav-link"
      classes += " active" if @state.currentTab == tab

      <li key={tab} className="nav-item">
        <a className={classes}
           data-text={tab}
           href="#"
           onClick={@selectFilterTab.bind(this, tab)}>
          {tab}
        </a>
      </li>
    )

    <ul className="nav filter-tabs">
      {renderedTabs}
    </ul>

  renderSearchField: ->
    if @state.searchTerm != ''
      clearButtonClasses = "btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-1"
    else
      clearButtonClasses = "d-none"

    <div className="search-wrapper position-relative mt-4">
      <input type="text"
             className="form-control"
             autoFocus="autofocus"
             placeholder="Type here to search books by name…"
             value={@state.searchTerm}
             onChange={@updateSearchTerm} />
      <button className={clearButtonClasses}
              type="button"
              onClick={@clearSearchTerm}>
        <i className="fas fa-times opacity-50" />
      </button>
    </div>

  renderTable: ->
    filteredBooks = @filteredBooks()

    <table className="table table-striped table-hover mt-2 mb-5">
      <thead>
        <tr>
          <th className="identifier">#</th>
          <th className="name">Name</th>
          <th className="languages">Languages</th>
          <th className="engine">Engine</th>
          <th className="status">Status</th>
          <th className="cost">Cost</th>
          <th className="actions"></th>
        </tr>
      </thead>
      <tbody>
        { @renderNoBooksFound() if filteredBooks.length == 0 }
        { filteredBooks.map(@renderTableRow.bind(this)) }
      </tbody>
    </table>

  renderNoBooksFound: ->
    <tr>
      <td colSpan="7" className="text-center">
        No books found
      </td>
    </tr>

  renderTableRow: (book) ->
    classes = ""
    classes += " #{book.invoicingStatus}"
    classes += " selected" if @state.selectedBookIds.includes(book.id)
    classes += " deleted"  if book.isDestroyed

    <tr key={book.id} className={classes}>
      { @renderIdentifier(book) }
      { @renderName(book)       }
      { @renderLanguages(book)  }
      { @renderEngine(book)     }
      { @renderStatus(book)     }
      { @renderCost(book)       }
      { @renderActions(book)    }
    </tr>

  renderIdentifier: (book) ->
    classes = "identifier"
    classes += " pointer" if @props.admin # other cursor for admin selection

    <td className={classes}
        title={@invoicingStatusText(book)}
        onClick={@toggleBookSelection.bind(this, book)}>
      <span>
        {book.id}
      </span>
    </td>

  renderName: (book) ->
    <td className="name">
      <a href={book.path} className="title" title={book.name}>
        {@renderBookName(book.name)}
      </a>
      { @renderCropToUnit(book) }
      <br/>
      { @renderSourceFile(book) }
    </td>

  renderBookName: (name) ->
    if @state.searchTerm.trim() == ''
      name
    else
      # Construct highlight even if accentuation doesn't match
      regex  = new RegExp("#{_.escapeRegExp(@normalize(@state.searchTerm))}")
      groups = @normalize(name).match(regex)
      index  = groups.index     # position of matched group
      length = groups[0].length # length of matched group

      part1 = name.substring(0, index)
      part2 = "<mark>" + name.substring(index, index + length) + "</mark>"
      part3 = name.substring(index + length, name.length)

      <span dangerouslySetInnerHTML={{ __html: "#{part1}#{part2}#{part3}" }}></span>

  renderCropToUnit: (book) ->
    if book.cropToUnitName
      lastUnit = book.cropToUnitName.split('-').pop()

      <span className="crop-to">
        (→ unit {lastUnit})
      </span>

  renderSourceFile: (book) ->
    <a href={book.sourceFileUrl} title={book.sourceFilename} className="source-file text-decoration-none">
      <i className="far fa-file-lines me-1" />
      {book.sourceFilename}
    </a>

  renderLanguages: (book) ->
    <td className="languages">
      {book.languageCombination}
    </td>

  renderEngine: (book) ->
    <td className="engine">
      {book.engineText}
      <br/>
      <span className="badge" style={{ backgroundColor: 'rgb(59 175 199)'}}>
        {book.segmenterText}
      </span>
      &nbsp;
      <span className="badge" style={{ backgroundColor: '#ce7ece'}}>
        {book.styleText}
      </span>
      &nbsp;
      <span className="badge" style={{ backgroundColor: 'rgb(216 173 61)'}}>
        {book.creativityText}
      </span>
    </td>

  renderStatus: (book) ->
    <td className="status">
      <span className="badge badge-#{book.status} rounded-pill">
        { book.status }
        { @renderSpinnerIcon() if book.status == 'progress' }
      </span>
    </td>

  renderSpinnerIcon: (book) ->
    <i className="fas fa-spinner fa-spin ms-1" />

  renderCost: (book) ->
    <td className="cost" title={@invoicingStatusText(book)}>
      <i className="fas fa-xs fa-check"></i>
      <i className="fas fa-xs fa-heart"></i>
      <span>
        {book.billableAmountFormatted}
      </span>
    </td>

  renderActions: (book) ->
    <td className="actions">
      <div className="dropdown">
        <button className="btn btn-primary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          Actions&nbsp;
        </button>
        <ul className="dropdown-menu dropdown-menu-end">
          { @renderResumeTranslationLink(book)      }
          { @renderBookRenameLink(book)             }
          { @renderSourceFileDownloadLink(book)     }
          { @renderTranslatedFileDownloadLink(book) }
          { @renderBookDeleteLink(book)             }
        </ul>
      </div>
    </td>

  renderResumeTranslationLink: (book) ->
    if book.canResumeTranslation
      <>
        <li>
          <a href={book.resumeTranslationPath} data-method="put" className="dropdown-item" style={{ color: '#239abd'}} >
            Resume translation
          </a>
        </li>
        { @renderDropdownDivider() }
      </>

  renderBookRenameLink: (book) ->
    if book.canBeRenamed
      <li>
        <a href="#"
           className="dropdown-item"
           onClick={@editBook.bind(this, book)}>
          Rename book
        </a>
      </li>

  renderSourceFileDownloadLink: (book) ->
    <li>
      <a href={book.sourceFileUrl} className="dropdown-item">
        Download source
      </a>
    </li>

  renderTranslatedFileDownloadLink: (book) ->
    if book.targetFileUrl
      <li>
        <a href={book.targetFileUrl} className="dropdown-item">
          Download translation
        </a>
      </li>

  renderBookDeleteLink: (book) ->
    if (book.canBeDestroyed || @props.admin) && !book.isDestroyed
      <>
        { @renderDropdownDivider() }
        <li>
          <a href={book.path} data-method="delete" data-confirm="Are you sure you want to delete this book?" className="dropdown-item text-danger">
            Delete book
          </a>
        </li>
      </>

  renderDropdownDivider: ->
    <li>
      <hr className="dropdown-divider" />
    </li>

  renderRenameModal: ->
    <Modal modalId={EDIT_MODAL_ID}
           environment={@props.environment}
           book={@state.editedBook}
           updateBook={@updateBook}
           hideModal={@hideModal} />
